import { useEffect } from "react";
import './loading.style.scss'

const Loading = () => {

  useEffect(() => {
    import("@lottiefiles/lottie-player");
  }, []);

  return (
    <div className="loading-container flex items-center justify-center">
      <div className="overlayPage flex items-center justify-center">
        <div className="box-grid">
          {/* @ts-expect-error lottie-player is a web component from @lottiefiles/lottie-player */}
          <lottie-player
            id="firstLottie"
            autoplay
            loop
            mode="normal"
            src="/images/loading.json"
          >
            {/* @ts-expect-error lottie-player closing tag */}
          </lottie-player>
        </div>
      </div>
    </div>
  );
}

export default Loading